import React, { Component, Fragment } from 'react';
import {
  Button, Container, Divider, Grid, Table,
} from 'semantic-ui-react';
import Loading from '../../../components/Loading';
import AccionesPerfil from './AccionesPerfil';

class Pacientes extends Component {
  componentDidMount() {
    const { getAllPacientes } = this.props;
    getAllPacientes();
  }

  handleOpenHistoriaClinica(id) {
    const { router } = this.props;
    router.push(`${id}/historiaClinica/`);
  }

  handleNuevoPaciente() {
    const { router } = this.props;
    router.push('/pacientes/nuevoPaciente');
  }

  render() {
    const { pacientes, isLoading } = this.props;
    if (isLoading) {
      return (<Loading />);
    }

    if (pacientes) {
      return (
        <Fragment>
          <Container className="container-margins">
            <Grid>
              <Grid.Row style={{ paddingBottom: 0 }}>
                <Grid.Column width={16}>
                  <h3>Mis pacientes</h3>
                  <Divider />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ paddingTop: 0 }}>
                <Grid.Column width={16}>
                  <Button onClick={() => this.handleNuevoPaciente()} content="Vincular o agregar nuevo paciente" color="teal" floated="right" icon="add user" labelPosition="right" style={{ marginBottom: '20px' }} />
                  <Table color="teal" selectable>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Nro Legajo</Table.HeaderCell>
                        <Table.HeaderCell>Raza</Table.HeaderCell>
                        <Table.HeaderCell>Nombre</Table.HeaderCell>
                        <Table.HeaderCell>Propietario</Table.HeaderCell>
                        <Table.HeaderCell textAlign="right">Elegí una acción a realizar</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {
                        pacientes.embedded.pacientes.map((p) => (
                          <Table.Row key={p.id}>
                            <Table.Cell>{p.legajo}</Table.Cell>
                            <Table.Cell>{p.raza}</Table.Cell>
                            <Table.Cell>{p.nombre}</Table.Cell>
                            <Table.Cell>{p.nombrePropietario}</Table.Cell>
                            <Table.Cell textAlign="right">
                              <AccionesPerfil popUpPosition="top center" buttonGroupSize="medium" dniPaciente={p.dni} idPaciente={p.id} {...this.props} />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Fragment>
      );
    }

    return (<div />);
  }
}

Pacientes.propTypes = {
};

export default Pacientes;



// WEBPACK FOOTER //
// ./src/routes/Pacientes/components/Pacientes.js